import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import NotFoundPage from "./pages/NotFoundPage";
import CommunityManagementPage from "./pages/SuperAdmin/CommSuperAdmin/CommunityManagementPage";
import NewCommunityPage from "./pages/SuperAdmin/CommSuperAdmin/NewCommunityPage";
import EditCommunityPage from "./pages/SuperAdmin/CommSuperAdmin/EditCommunityPage";
import ViewCommunityPage from "./pages/SuperAdmin/CommSuperAdmin/ViewCommunityPage";
import UserManagementPage from "./pages/SuperAdmin/UserSuperAdmin/UserManagementPage";
import NewUserPage from "./pages/SuperAdmin/UserSuperAdmin/NewUserPage";
import ViewUserPage from "./pages/SuperAdmin/UserSuperAdmin/ViewUserPage";
import PendingRequests from "./pages/SuperAdmin/PendingRequests";
import ViewRequest from "./pages/SuperAdmin/ViewRequest";
import POCManagement from "./pages/SuperAdmin/POCSuperAdmin/POCManagement";
import EditPOCPage from "./pages/SuperAdmin/POCSuperAdmin/EditPOCPage";
import ViewPOCPage from "./pages/SuperAdmin/POCSuperAdmin/ViewPOCPage";
import NewPOCPage from "./pages/SuperAdmin/POCSuperAdmin/NewPOCPage";
import Dashboard from "./pages/Dashboard";
import MaterialManagement from "./pages/SuperAdmin/MaterialSuperAdmin/MaterialManagement";
import MemberManagement from "./pages/MemManageCommAdmin//MemberManagement";
import Settings from "./pages/Settings";
import DashboardCom from "./pages/MemManageCommAdmin/DashboardCom";
import GroupManagement from "./pages/MemManageCommAdmin/GroupManagement";
import ViewGroupDetails from "./pages/MemManageCommAdmin/ViewGroupDetails";
import EditGroupDetails from "./pages/MemManageCommAdmin/EditGroupDetails";
import AddGroup from "./pages/MemManageCommAdmin/AddGroup";
import GroupAdminRequests from "./pages/GroupAdmin/GroupAdminRequests";
import POCAttendant from "./pages/POCAttendant/POCAttendant";
import POCCollector from "./pages/Collector/POCCollector";
import Transactions from "./pages/SuperAdmin/Transactions";
import News from "./pages/SuperAdmin/News";
import MemDashboard from "./pages/Member/MemDashboard";
import MemberCommunity from "./pages/Member/MemberCommunity";
import ViewCommunity from "./pages/Member/ViewCommunity";
import ViewOwnAccount from "./pages/ViewAccount";
import Layout from "./components/Layout";
import { ToastContainer } from "react-toastify";
import EditOwnAccount from "./pages/EditAccount";
import InviteLogin from "./pages/InvitationPages/InviteLogin";
import ResetPassword from "./pages/InvitationPages/ResetPassword";
import SuccessPage from "./pages/InvitationPages/SuccessPage";
import Expired from "./pages/InvitationPages/Expired";
import ProfileSelect from "./pages/InvitationPages/ExistingUser/ProfileSelect";
import AccountCreation from "./pages/InvitationPages/NewUser/AccountCreation";
// import CreateProfile from "./pages/InvitationPages/NewUser/CreateProfile";
import MyTransactions from "./pages/Member/MyTransactions";
import MyRequests from "./pages/Member/MyRequests";
import CheckInQRCode from "./pages/POCAttendant/Newqr";
import useMaterialStore from "./stores/materialStore";
import CaPending from "./pages/MemManageCommAdmin/PendingRequests";
import CaPendingView from "./pages/MemManageCommAdmin/ViewComRequest";
import ExpandedMaterials from "./pages/ExpandedMaterials";
import { useProfileInit } from "./stores/profileStore";
import AuthGuard from "./components/AuthGuard";
import EditProfile from "./pages/EditProfile";

function App() {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const { fetchMaterials, materials } = useMaterialStore();

  useProfileInit();

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  // Fetch materials when app loads (if empty)
  useEffect(() => {
    if (materials.length === 0) {
      fetchMaterials();
    }
  }, [fetchMaterials]);

  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/login" replace state={{ from: "/" }} />}
        />

        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes with Sidebar */}
        <Route
          element={
            <Layout
              isMobileOpen={isMobileOpen}
              toggleMobileSidebar={toggleMobileSidebar}
            />
          }
        >
          <Route element={<AuthGuard />}>
            {/* View and Edit Own Account */}
            <Route path="/view-account/:userId" element={<ViewOwnAccount />} />
            <Route path="/edit-account/:userId" element={<EditOwnAccount />} />
            <Route path="/edit-profile/:profileId" element={<EditProfile />} />

            {/* Super Admin Pages */}
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/news" element={<News />} />
            {/* pending requests */}
            <Route path="/pending-requests" element={<PendingRequests />} />
            <Route
              path="/pending-requests/view/:requestId"
              element={<ViewRequest />}
            />

            {/*Super admin community page */}
            <Route path="/communities" element={<CommunityManagementPage />} />
            <Route path="/communities/add" element={<NewCommunityPage />} />
            <Route
              path="/communities/edit/:communityId"
              element={<EditCommunityPage />}
            />
            <Route
              path="/communities/view/:communityId"
              element={<ViewCommunityPage />}
            />

            {/*Super admin User page */}
            <Route path="/users" element={<UserManagementPage />} />
            <Route path="/users/add" element={<NewUserPage />} />
            <Route path="/users/view/:userId" element={<ViewUserPage />} />

            {/*Super admin POC page */}
            <Route path="/poc" element={<POCManagement />} />
            <Route path="/poc/edit/:POCID" element={<EditPOCPage />} />
            <Route path="/poc/view/:POCID" element={<ViewPOCPage />} />
            <Route path="/poc/add" element={<NewPOCPage />} />

            {/* Super admin dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Super admin material management */}
            <Route
              path="/material-management"
              element={<MaterialManagement />}
            />

            {/* Super admin Settings */}
            <Route path="/settings" element={<Settings />} />

            {/* Community Admin Pages */}
            <Route
              path="/comm-dashboard/:communityId"
              element={<DashboardCom />}
            />
            <Route
              path="/member-management/:communityId"
              element={<MemberManagement />}
            />
            <Route path="/ca/pending/:communityId" element={<CaPending />} />
            <Route
              path="/ca/pending/view/:requestId"
              element={<CaPendingView />}
            />
            <Route path="/group-management" element={<GroupManagement />} />
            <Route
              path="/group-management/:communityId"
              element={<GroupManagement />}
            />
            <Route
              path="/group-management/view/:groupId"
              element={<ViewGroupDetails />}
            />
            <Route
              path="/group-management/edit/:groupId"
              element={<EditGroupDetails />}
            />
            <Route path="/group-management/add" element={<AddGroup />} />

            {/* Group admin */}
            <Route
              path="/group-admin/:groupId"
              element={<GroupAdminRequests />}
            />

            {/* POC Attendant */}
            <Route path="/pocattendant" element={<POCAttendant />} />

            {/* POC Collector */}
            <Route path="/poccollector" element={<POCCollector />} />

            {/* Member Screens */}
            <Route path="/member-dashboard" element={<MemDashboard />} />

            <Route path="/community-management" element={<MemberCommunity />} />
            <Route
              path="/view-communities/:communityId"
              element={<ViewCommunity />}
            />
            <Route path="/my-transactions" element={<MyTransactions />} />
            <Route path="/my-requests" element={<MyRequests />} />
            <Route path="/materials" element={<ExpandedMaterials />} />
          </Route>
          {/* Catch-all 404 route - must be last */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        <Route
          path="/account/reset-password/:idAndToken"
          element={<ResetPassword />}
        />
        <Route path="/:mode/login/*" element={<InviteLogin />} />
        <Route path="/:mode/login/profileselect/" element={<ProfileSelect />} />
        <Route path="/:mode/new/:token" element={<AccountCreation />} />

        <Route path="/invitesuccess" element={<SuccessPage />} />
        <Route path="/expired" element={<Expired />} />
        <Route path="/newqr" element={<CheckInQRCode />} />
      </Routes>
    </Router>
  );
}

export default App;
